// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.billing-page {
  min-height: 100vh;
  background: #f6f8fb;
  box-sizing: border-box;
}

.billing-shell {
  max-width: 1080px;
  margin: 0 auto;
  padding: 78px 24px 40px;
}

.billing-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.billing-header h1 {
  margin: 0;
  font-size: 1.55rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.03em;
  line-height: 1.2;
}

.billing-header p {
  margin: 6px 0 0;
  color: #64748b;
  font-size: 0.9rem;
  line-height: 1.45;
}

.billing-loading {
  padding: 48px 16px;
  text-align: center;
  color: #64748b;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
}

.billing-summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 14px;
}

@media (max-width: 760px) {
  .billing-summary {
    grid-template-columns: 1fr;
  }

  .billing-shell {
    padding: 72px 16px 32px;
  }
}

.billing-summary-card,
.billing-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 18px 20px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.billing-card {
  margin-bottom: 14px;
}

.billing-kicker {
  margin: 0 0 4px;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #94a3b8;
}

.billing-summary-card h2 {
  margin: 0 0 14px;
  font-size: 1.35rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.billing-stat-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}

.billing-stat-grid > div {
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 10px;
  padding: 10px 12px;
}

.billing-stat-grid span {
  display: block;
  font-size: 0.72rem;
  color: #64748b;
  margin-bottom: 4px;
}

.billing-stat-grid strong {
  font-size: 1rem;
  color: #0f172a;
  font-weight: 700;
}

.billing-feature-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.billing-feature-pills li {
  background: #eef8fe;
  color: #0369a1;
  font-size: 0.75rem;
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 999px;
}

.billing-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.billing-card-head h2 {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.billing-card-head p {
  margin: 4px 0 0;
  font-size: 0.84rem;
  color: #64748b;
}

.billing-plans-grid {
  margin-top: 4px;
}

.billing-btn {
  background: #07a6ef;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 0.55rem 1.05rem;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.9rem;
  transition: background 0.15s ease;
}

.billing-btn:hover {
  background: #0596d8;
}

.billing-btn.small {
  padding: 0.35rem 0.75rem;
  font-size: 0.8rem;
  border-radius: 8px;
}

.billing-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.billing-meter {
  height: 10px;
  background: #e2e8f0;
  border-radius: 999px;
  overflow: hidden;
  margin: 0.5rem 0 0.85rem;
}

.billing-meter-fill {
  height: 100%;
  background: #07a6ef;
  border-radius: inherit;
  transition: width 0.2s ease;
}

.billing-meter-fill.warn {
  background: #f59e0b;
}

.billing-meter-fill.over {
  background: #ef4444;
}

.billing-usage-text {
  margin: 0;
  color: #334155;
  font-size: 0.92rem;
}

.billing-usage-text strong {
  color: #0f172a;
  font-size: 1.05rem;
}

.billing-muted {
  margin: 8px 0 0;
  color: #94a3b8;
  font-size: 0.8rem;
}

.billing-warn {
  margin: 8px 0 0;
  color: #b45309;
  font-weight: 500;
  font-size: 0.85rem;
}

.billing-banner {
  padding: 0.8rem 1rem;
  border-radius: 12px;
  margin-bottom: 14px;
  font-size: 0.9rem;
  line-height: 1.45;
}

.billing-banner.danger {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #991b1b;
}

.billing-banner.warn {
  background: #fffbeb;
  border: 1px solid #fde68a;
  color: #92400e;
}

.billing-empty {
  padding: 28px 16px;
  text-align: center;
  color: #64748b;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  font-size: 0.9rem;
}

.billing-table-wrap {
  overflow-x: auto;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.billing-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 560px;
}

.billing-table th,
.billing-table td {
  text-align: left;
  padding: 0.75rem 0.9rem;
  border-bottom: 1px solid #f1f5f9;
  font-size: 0.88rem;
  color: #334155;
}

.billing-table th {
  background: #f8fafc;
  color: #64748b;
  font-weight: 600;
  font-size: 0.75rem;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.billing-table tbody tr:last-child td {
  border-bottom: none;
}

.billing-table tbody tr:hover td {
  background: #fafcff;
}

.billing-status {
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: capitalize;
  background: #f1f5f9;
  color: #475569;
}

.billing-status.paid {
  background: #ecfdf5;
  color: #047857;
}

.billing-status.pending {
  background: #fffbeb;
  color: #b45309;
}

.billing-status.overdue {
  background: #fef2f2;
  color: #b91c1c;
}
`, "",{"version":3,"sources":["webpack://./src/Css/Billing.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".billing-page {\n  min-height: 100vh;\n  background: #f6f8fb;\n  box-sizing: border-box;\n}\n\n.billing-shell {\n  max-width: 1080px;\n  margin: 0 auto;\n  padding: 78px 24px 40px;\n}\n\n.billing-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.billing-header h1 {\n  margin: 0;\n  font-size: 1.55rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.03em;\n  line-height: 1.2;\n}\n\n.billing-header p {\n  margin: 6px 0 0;\n  color: #64748b;\n  font-size: 0.9rem;\n  line-height: 1.45;\n}\n\n.billing-loading {\n  padding: 48px 16px;\n  text-align: center;\n  color: #64748b;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n}\n\n.billing-summary {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 14px;\n}\n\n@media (max-width: 760px) {\n  .billing-summary {\n    grid-template-columns: 1fr;\n  }\n\n  .billing-shell {\n    padding: 72px 16px 32px;\n  }\n}\n\n.billing-summary-card,\n.billing-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  padding: 18px 20px;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.billing-card {\n  margin-bottom: 14px;\n}\n\n.billing-kicker {\n  margin: 0 0 4px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.billing-summary-card h2 {\n  margin: 0 0 14px;\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.02em;\n}\n\n.billing-stat-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.billing-stat-grid > div {\n  background: #f8fafc;\n  border: 1px solid #f1f5f9;\n  border-radius: 10px;\n  padding: 10px 12px;\n}\n\n.billing-stat-grid span {\n  display: block;\n  font-size: 0.72rem;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.billing-stat-grid strong {\n  font-size: 1rem;\n  color: #0f172a;\n  font-weight: 700;\n}\n\n.billing-feature-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.billing-feature-pills li {\n  background: #eef8fe;\n  color: #0369a1;\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 5px 10px;\n  border-radius: 999px;\n}\n\n.billing-card-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.billing-card-head h2 {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.02em;\n}\n\n.billing-card-head p {\n  margin: 4px 0 0;\n  font-size: 0.84rem;\n  color: #64748b;\n}\n\n.billing-plans-grid {\n  margin-top: 4px;\n}\n\n.billing-btn {\n  background: #07a6ef;\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  padding: 0.55rem 1.05rem;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 0.9rem;\n  transition: background 0.15s ease;\n}\n\n.billing-btn:hover {\n  background: #0596d8;\n}\n\n.billing-btn.small {\n  padding: 0.35rem 0.75rem;\n  font-size: 0.8rem;\n  border-radius: 8px;\n}\n\n.billing-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.billing-meter {\n  height: 10px;\n  background: #e2e8f0;\n  border-radius: 999px;\n  overflow: hidden;\n  margin: 0.5rem 0 0.85rem;\n}\n\n.billing-meter-fill {\n  height: 100%;\n  background: #07a6ef;\n  border-radius: inherit;\n  transition: width 0.2s ease;\n}\n\n.billing-meter-fill.warn {\n  background: #f59e0b;\n}\n\n.billing-meter-fill.over {\n  background: #ef4444;\n}\n\n.billing-usage-text {\n  margin: 0;\n  color: #334155;\n  font-size: 0.92rem;\n}\n\n.billing-usage-text strong {\n  color: #0f172a;\n  font-size: 1.05rem;\n}\n\n.billing-muted {\n  margin: 8px 0 0;\n  color: #94a3b8;\n  font-size: 0.8rem;\n}\n\n.billing-warn {\n  margin: 8px 0 0;\n  color: #b45309;\n  font-weight: 500;\n  font-size: 0.85rem;\n}\n\n.billing-banner {\n  padding: 0.8rem 1rem;\n  border-radius: 12px;\n  margin-bottom: 14px;\n  font-size: 0.9rem;\n  line-height: 1.45;\n}\n\n.billing-banner.danger {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #991b1b;\n}\n\n.billing-banner.warn {\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n  color: #92400e;\n}\n\n.billing-empty {\n  padding: 28px 16px;\n  text-align: center;\n  color: #64748b;\n  background: #f8fafc;\n  border: 1px dashed #cbd5e1;\n  border-radius: 12px;\n  font-size: 0.9rem;\n}\n\n.billing-table-wrap {\n  overflow-x: auto;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n}\n\n.billing-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 560px;\n}\n\n.billing-table th,\n.billing-table td {\n  text-align: left;\n  padding: 0.75rem 0.9rem;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 0.88rem;\n  color: #334155;\n}\n\n.billing-table th {\n  background: #f8fafc;\n  color: #64748b;\n  font-weight: 600;\n  font-size: 0.75rem;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.billing-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.billing-table tbody tr:hover td {\n  background: #fafcff;\n}\n\n.billing-status {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 9px;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: capitalize;\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.billing-status.paid {\n  background: #ecfdf5;\n  color: #047857;\n}\n\n.billing-status.pending {\n  background: #fffbeb;\n  color: #b45309;\n}\n\n.billing-status.overdue {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
